import React, { forwardRef } from "react";
import "./TextField.css";

type TextFieldProps = React.ComponentPropsWithoutRef<"input"> & {
  label?: string;
  helperText?: string;
  isError?: boolean;
};

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ className = "", label, helperText, isError, ...otherProps }, ref) => {
    return (
      <label className={`sr-text-input-container ${className}`}>
        {label && (
          <span
            className={`sr-text-label ${
              otherProps.disabled ? "sr-text-label-disabled" : ""
            }`}
          >
            {label}
          </span>
        )}
        <input
          ref={ref}
          className={`sr-text-input ${isError ? "sr-error" : ""}`}
          type="text"
          {...otherProps}
        />
        {helperText && (
          <span
            className={`sr-text-helper-text ${
              isError ? "sr-text-helper-text-error" : ""
            }`}
          >
            {helperText}
          </span>
        )}
      </label>
    );
  }
);

export { TextField };
export type { TextFieldProps };
